import React, { useState } from 'react';
import '../../../../styles/VocuherModal.scss';

interface Voucher {
  id: string;
  code: string;
  name?: string;
  discount_type: string;
  discount_value: string;
  min_spend?: string;
  max_discount?: string;
  end_at?: string;
}

interface Props {
  storeName: string;
  vouchers: Voucher[];
  appliedVoucherId?: string | null;
  onApply: (voucher_id: string) => void;
  onClose: () => void;
}

const VoucherModal: React.FC<Props> = ({
  storeName,
  vouchers,
  appliedVoucherId,
  onApply,
  onClose,
}) => {

  const [selectedVoucher, setSelectedVoucher] = useState<Voucher | null>(null);

  const formatDate = (dateString?: string) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-PH', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };

  const handleUseVoucher = (voucherId: string) => {
    onApply(voucherId);
  };

  return (
    <div className="modal-backdrop">
      <div className="voucher-modal">

        {/* ===================== */}
        {/* ===== LIST VIEW ===== */}
        {/* ===================== */}
        {!selectedVoucher && (
          <>
            <h2>{storeName}'s Voucher</h2>

            {vouchers.length === 0 && (
              <p className="no-voucher">No available vouchers.</p>
            )}

            <div className="voucher-list">
              {vouchers.map((voucher) => {
                const isApplied = appliedVoucherId === voucher.id;

                return (
                  <div key={voucher.id} className="voucher-card">

                    <div className="voucher-left" />

                    <div className="voucher-content">
                      <h3>
                        ₱{parseFloat(voucher.discount_value).toFixed(2)} OFF
                      </h3>

                      {voucher.min_spend && (
                        <p className="min-spend">
                          Min. Spend of ₱{parseFloat(voucher.min_spend).toFixed(2)}
                        </p>
                      )}

                      {voucher.end_at && (
                        <p className="valid-until">
                          Valid Until: {formatDate(voucher.end_at)}
                        </p>
                      )}

                      <span
                        className="tc-link"
                        onClick={() => setSelectedVoucher(voucher)}
                      >
                        T&C
                      </span>
                    </div>

                    <div className="voucher-action">
                      <button
                        className={`use-btn ${isApplied ? 'applied' : ''}`}
                        disabled={isApplied}
                        onClick={() => handleUseVoucher(voucher.id)}
                      >
                        {isApplied ? 'Applied' : 'Use'}
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>

            <button className="cancel-btn" onClick={onClose}>
              Close
            </button>
          </>
        )}

        {/* ===================== */}
        {/* ===== T&C VIEW ====== */}
        {/* ===================== */}
        {selectedVoucher && (
          <div className="voucher-terms-view">

            <button
              className="back-btn"
              onClick={() => setSelectedVoucher(null)}
            >
              ← Back
            </button>

            <h2 className="voucher-name">
              {selectedVoucher.name || 'Voucher'}
            </h2>

            <h3 className="voucher-discount">
              ₱{parseFloat(selectedVoucher.discount_value).toFixed(2)} OFF
            </h3>

            <div className="terms-section">
              <h4>Terms & Conditions</h4>
              <ul>
                {selectedVoucher.min_spend && (
                  <li>
                    Spend minimum amount of ₱
                    {parseFloat(selectedVoucher.min_spend).toFixed(2)}
                  </li>
                )}

                {selectedVoucher.end_at && (
                  <li>
                    Valid until: {formatDate(selectedVoucher.end_at)}
                  </li>
                )}

                <li>Not applicable to sale or discounted items</li>
                <li>Only one voucher code can be used per transaction.</li>
              </ul>
            </div>

            <button
              className={`use-btn full-width ${
                appliedVoucherId === selectedVoucher.id ? 'applied' : ''
              }`}
              disabled={appliedVoucherId === selectedVoucher.id}
              onClick={() => handleUseVoucher(selectedVoucher.id)}
            >
              {appliedVoucherId === selectedVoucher.id
                ? 'Applied'
                : 'Use Voucher'}
            </button>
          </div>
        )}

      </div>
    </div>
  );
};

export default VoucherModal;